import React, {Component} from 'react';
import simpleStore from '../simpleStore';
import './HelpButton.css'

let HelpButton = () => {
    return (
        <div>
        <div className='center-camera-button'>
            <a data-target="modal1" className="btn modal-trigger btn-floating btn-large waves-effect waves-light black"><i className="material-icons">help_outline</i></a>
        </div>
        <div id="modal1" class="modal">
            <div class="modal-content">
            <h4>Force Graph Three Experiment</h4>
            <p>This is a force directed tree graph made with three.js.</p>
            <p>Opposing forces push nodes away from each other while spring forces hold the structure of the tree in place.</p>
            <p>You can adjust the number of generations the tree has and the number of branches each node creates in a generation.</p>
            <p>Try dragging the nodes around. Use the pin switch to choose whether or not to fix the node to a location or release it to the graph forces.</p>
            <p>I hope you enjoy this experiment. Thanks, Michael Deitcher</p>
            </div>
        </div>   
      </div>
    );
}

export default HelpButton;